import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2, Clock } from "lucide-react";

export default function AgentCustomers() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/agent/customers").then((r) => setData(r.data));
  }, []);

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">My customers</h1>
        <p className="text-sm text-muted-foreground">
          You keep earning on repeat orders for {data.ownership_window_months} months after onboarding.
        </p>
      </div>
      {data.customers.length === 0 ? (
        <p className="text-sm text-muted-foreground py-12 text-center">No customers onboarded yet.</p>
      ) : (
        <div className="space-y-3">
          {data.customers.map((c, i) => (
            <Card key={i} className="p-4" data-testid={`customer-row-${i}`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-medium">{c.name}</p>
                  <p className="text-xs text-muted-foreground">Onboarded {c.onboarding_date}</p>
                </div>
                {c.is_new && <Badge>New</Badge>}
              </div>
              <div className="flex items-center gap-2 mt-3 text-xs">
                <Clock className="w-3.5 h-3.5 text-muted-foreground" />
                {c.repeat_credited ? (
                  <span className="text-primary font-medium">{c.ownership_days_left} days left — repeat orders credited to you</span>
                ) : (
                  <span className="text-muted-foreground">Ownership window expired</span>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
